import React, { FC } from 'react';
import { Button, Spin } from 'antd';
import { formatPhoneNumber } from 'common/helpers';
import { Phone } from 'common/const/svg';

interface IComponentProps {
  phone?: string;
  loading: boolean;
  onCall: boolean;
  onCallClick: () => void;
}

export const VoiceCall: FC<IComponentProps> = ({ phone, loading, onCall, onCallClick }) => {
  return (
    <div className="call">
      <div className="mb-7 ff-medium fs-lg">Calls</div>

      <div className="d-flex align-center justify-between">
        <div className="ff-medium fs-md">Phone: {formatPhoneNumber(phone)}</div>

        <Button className="blue" icon={loading ? <Spin size="small" /> : <Phone />} onClick={onCallClick} disabled={onCall}>
          Audio call
        </Button>
      </div>
    </div>
  );
};
